<template>
	<div>
		<loading v-if="loading" :full-page="true"></loading>

		<div v-else-if="!error">
			<div class="title-container">
				<div class="title"><span class="fa fa-exclamation-triangle"></span>Respond To Invitation</div>
			</div>

			<form-errors v-if="hasErrors" :errors="errors"></form-errors>

			<div class="input-container">
				<div class="input-static-text">
					You've been invited to join the {{ account.name }} account
					<ul>
						<li v-if="invitation.has_admin_access">Full Access</li>
						<li v-if="invitation.can_manage_users">Can Manage Users</li>
					</ul>
				</div>
			</div>
			<div v-if="!formSaving" class="split-input-buttons">
				<div class="split-input-buttons-cell"><button @click.prevent="accept" type="submit" class="submit-standard good-bg">Accept Invitation<span class="fa fa-thumbs-up"></span></button></div>
				<div class="split-input-buttons-cell"><button @click.prevent="reject" type="submit" class="submit-standard bad-bg">Decline Invitation<span class="fa fa-thumbs-down"></span></button></div>
			</div>
			<submit-button v-if="formSaving" :loading="formSaving"></submit-button>
		</div>
		<div v-else>
			<div class="title-container">
				<div class="title"><span class="fa fa-exclamation-triangle"></span>Invitation Issue</div>
			</div>
			<div class="input-container">
				<div class="input-static-text">{{ error }}</div>
			</div>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import FormMixin from '@/mixins/FormMixin';

export default {

	mixins: [ FormMixin ],

	data() {
		return {
			loading: true,
			account: {},
			invitation: {},
			error: null,
		};
	},

	computed: mapGetters([ 'isLoggedIn', 'currentUser' ]),

	created() {
		this.loadInvitation();
	},

	methods: {

		async loadInvitation() {
			this.loading = true;

			// Load invitation from server
			try {
				const { data } = await this.$api.post(`/account/connections/${ this.$route.params.accountId }/${ this.$route.params.userId }/respond`, { signature: this.$route.params.signature });

				this.account = data.data.account;
				this.invitation = data.data;
			} catch (e) {
				this.error = this.$api.getErrorMessage(e);
				this.$store.dispatch('addToast', { message: this.error, type: 'bad' });
			}

			this.loading = false;
		},

		accept() {
			this.sendResponse('accept');
		},

		reject() {
			this.sendResponse('reject');
		},

		async sendResponse(response) {
			this.submit(async () => {
				await this.$api.post(`/account/connections/${ this.$route.params.accountId }/${ this.$route.params.userId }/${ response }`, { signature: this.$route.params.signature });

				this.$store.commit('clearPendingInvitation');
				this.$store.dispatch('getAccounts');
				this.$store.dispatch('addToast', 'You have accepted this invitation. Thank you for responding!');

				this.$router.replace({ name: 'accounts-switch', params: { id: this.$route.params.accountId }});

			}, (e) => {
				this.$store.dispatch('errorToast', 'There was a problem accepting this invitation. Please try again later.');
			});
		}

	},

};

</script>
